import { isTabletOrIpad } from './isTabletOrIpad';
import Browser from './core/hooks/Browser';
import TempCache from './core/enums/TempCache';

const isAutoLaunchChatWindow = (options) => {
    return (
        options.launchChatWindowEnabled &&
        !(options.isMobile || Browser.isiOS() || Browser.isAndroid()) &&
        !isTabletOrIpad()
    );
};
export default isAutoLaunchChatWindow;
